<template>
  <div class="app-page">
    <a-tabs type="card" v-model="activeKey">
      <a-tab-pane class="app-tab" key="appList" tab="应用列表">
        <div style="height: 62px">
          <div style="float: right;margin-top: 15px">
            <span style="font-size: 14px;font-weight: 400;color: rgba(0, 0, 0, 0.65);line-height: 20px;">共 {{ totalApp }}
              条</span>
            <a-button style="margin-left: 12px" type="primary" @click="handleOpenAddAppModal">
              新增应用
            </a-button>
          </div>
        </div>
        <div class="table-page__main">
          <global-table ref="tableApp" :columns="appColumns" :dataRender="loadAppData" :isShowTotal="false"
            :showPagination="true" @handleTotalChange="handleTotalAppChange" filled>
            <template v-slot:actionForApp="{ row, column, index }">
              <a href="javascript:;" @click="handleAppEdit(row.appId)">编辑</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确认删除？" ok-text="确定" cancel-text="取消" okType="danger"
                @confirm="handleAppDelete(row.appId)">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
              <a-divider type="vertical" />
              <a href="javascript:;" @click="handleShowAppBindList(row.appId)">绑定列表</a>
            </template>
            <template v-slot:toSignSecret="{ row }">
              <span>{{ row.signSecret.length > 6 ? row.signSecret.slice(0, 6).concat('***', row.signSecret.slice(-6))
                : row.signSecret }}</span>
              <a @click="$event => handleCopySign()" class="copySign" :data-clipboard-text="row.signSecret"> {{
                row.signSecret.length > 1 ? ' 复制' : '' }}</a>
            </template>
            <template v-slot:toVerifySecret="{ row }">
              <span>{{ row.verifySecret.length > 6 ? row.verifySecret.slice(0, 6).concat('***',
                row.verifySecret.slice(-6))
                : row.verifySecret }}</span>
              <a @click="$event => handleCopyVerify()" class="copyVerify" :data-clipboard-text="row.verifySecret"> {{
                row.verifySecret.length > 1 ? ' 复制' : '' }}</a>
            </template>
          </global-table>
          <app-bind-list-drawer :visible="isShowAppBindListDrawer" :id="chooseRowAppId"
            @close="handleAppBindListDrawerClose" />
          <app-detail-drawer :visible="isShowAppDetailDrawer" :id="chooseRowAppId" @close="handleAppDetailDrawerClose" />
          <a-modal v-model="isShowAddAppModal" width="546px" title="新增应用" @ok="handleAppAdd"
            :bodyStyle="addAppModalBodyStyle">
            <a-form :form="addAppForm">
              <a-form-item label="应用名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-input placeholder="请输入应用名称"
                  v-decorator="['appName', { rules: [{ required: true, message: '请输入应用名称' }] }]" />
              </a-form-item>
              <a-form-item label="应用备注" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-textarea placeholder="请输入应用备注" v-decorator="['comments']" :autoSize="addAppModalRemarkAutoSize"
                  style="height: 124px" />
              </a-form-item>
              <a-form-item label="应用域名" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-input placeholder="请输入应用域名"
                  v-decorator="['domain', { rules: [{ required: true, message: '请输入应用域名' }] }]" />
              </a-form-item>
              <a-form-item label="网站ICP备案" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" style="margin-bottom: 0">
                <a-input placeholder="请输入网站ICP备案"
                  v-decorator="['icp', { rules: [{ required: true, message: '请输入网站ICP备案' }] }]" />
              </a-form-item>
            </a-form>
            <template slot="footer">
              <div style="padding: 10px 4px">
                <div>
                  <button type="button" class="ant-btn" @click="isShowAddAppModal = false"><span>取 消</span></button>
                  <button type="button" class="ant-btn ant-btn-primary" @click="handleAppAdd"><span>保 存</span></button>
                </div>
              </div>
            </template>
          </a-modal>
        </div>
      </a-tab-pane>
      <a-tab-pane key="bindList" tab="用户绑定列表" style="padding: 0">
        <bind-relation-table></bind-relation-table>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>

import {
  Tabs, Button, Modal, Input, Popconfirm,
} from 'ant-design-vue';
import GlobalTable from '@/components/GlobalTable';
import {
  listAppByPageInCurrentUser, deleteApp, deleteRelation, createApp,
} from '@/services/modules/app-manage';
import Clipboard from 'clipboard';
import AppBindListDrawer from './AppBindListDrawer.vue';
import AppDetailDrawer from './AppDetailDrawer.vue';
import BindRelationTable from './BindRelationTable.vue';

export default {
  name: 'AppManage',
  components: {
    'a-tabs': Tabs,
    'a-tab-pane': Tabs.TabPane,
    'a-button': Button,
    'a-modal': Modal,
    'a-textarea': Input.TextArea,
    'a-popconfirm': Popconfirm,
    GlobalTable,
    AppDetailDrawer,
    AppBindListDrawer,
    BindRelationTable,
  },
  data() {
    return {
      activeKey: 'appList',
      outUserId: '',
      likeUserName: '',
      dateRange: [],
      isShowAppDetailDrawer: false,
      isShowAppBindListDrawer: false,
      isShowAddAppModal: false,
      chooseRowAppId: '',
      chooseRowAppInfo: {},
      totalApp: 0,
      addAppModalBodyStyle: { padding: '20px 20px 10px 20px' },
      addAppModalRemarkAutoSize: { minRows: 5 },
    };
  },
  beforeCreate() {
    this.addAppForm = this.$form.createForm(this, { name: 'add-app' });
  },
  computed: {
    appColumns() {
      return [
        {
          title: '应用编号',
          key: 'appId',
          align: 'left',
          minWidth: 100,
        },
        {
          title: '应用秘钥',
          key: 'appKey',
          align: 'left',
          minWidth: 180,
        },
        {
          title: '应用名称',
          key: 'appName',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '应用域名',
          key: 'domain',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '加签Key',
          key: 'signSecret',
          align: 'left',
          minWidth: 150,
          slot: 'toSignSecret',
        },
        {
          title: '验签Key',
          key: 'verifySecret',
          align: 'left',
          minWidth: 150,
          slot: 'toVerifySecret',
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '状态',
          key: 'statusDescription',
          align: 'left',
          minWidth: 125,
        },
        {
          title: '操作',
          align: 'left',
          fixed: 'right',
          width: 200,
          slot: 'actionForApp',
        },
      ];
    },
  },
  methods: {
    loadAppData(parameter) {
      return listAppByPageInCurrentUser(parameter);
    },
    handleCopySign() {
      const copyData = new Clipboard('.copySign');
      copyData.on('success', () => {
        this.$message.success('复制成功');
        // 释放内存
        copyData.destroy();
      });
      copyData.on('error', () => {
        this.$message.error('复制失败');
        // 释放内存
        copyData.destroy();
      });
    },
    handleCopyVerify() {
      const copyData = new Clipboard('.copyVerify');
      copyData.on('success', () => {
        this.$message.success('复制成功');
        // 释放内存
        copyData.destroy();
      });
      copyData.on('error', () => {
        this.$message.error('复制失败');
        // 释放内存
        copyData.destroy();
      });
    },
    handleAppEdit(id) {
      this.chooseRowAppId = id;
      this.isShowAppDetailDrawer = true;
    },
    handleShowAppBindList(id) {
      this.chooseRowAppId = id;
      this.isShowAppBindListDrawer = true;
    },
    handleAppDelete(id) {
      const params = { appId: id };
      deleteApp(params).then((res) => {
        if (res && res.success && res.result) {
          this.$message.success('删除成功');
          this.activeKey = 'appList';
          this.$refs.tableApp.refresh(true);
        } else {
          this.$message.error((res && res.errorMessage) || '删除失败，请重试');
        }
      });
    },
    handleBindRelationDelete(id) {
      const params = { relationId: id };
      deleteRelation(params).then((res) => {
        if (res && res.success && res.result) {
          this.$message.success('删除成功');
          this.activeKey = 'bindList';
          this.$refs.tableBind.refresh(true);
        } else {
          this.$message.error((res && res.errorMessage) || '删除失败，请重试');
        }
      });
    },
    handleAppAdd() {
      // eslint-disable-next-line no-underscore-dangle
      if (window.__POWERED_BY_QIANKUN__) {
        this.activeKey = 'appList';
        this.$refs.tableApp.refresh(true);
      } else {
        this.addAppForm.validateFields((err, values) => {
          if (!err) {
            createApp(values).then((res) => {
              if (res && res.success && res.result) {
                this.$message.success('新增成功');
                this.isShowAddAppModal = false;
                this.activeKey = 'appList';
                this.$refs.tableApp.refresh(true);
              } else {
                this.$message.error((res && res.errorMessage) || '新增失败，请重试');
              }
            });
          }
        });
      }
    },
    handleOpenAddAppModal() {
      // eslint-disable-next-line no-underscore-dangle
      if (window.__POWERED_BY_QIANKUN__) {
        window.handleAddModalOpen();
        console.log(window.addAppFinish);

        setTimeout(() => {
          window.addAppFinish(this.handleAppAdd);
        }, 2000);
      } else {
        this.isShowAddAppModal = true;
        this.addAppForm.resetFields();
      }
    },
    handleAppDetailDrawerClose() {
      this.isShowAppDetailDrawer = false;
      this.chooseRowAppId = '';
      this.activeKey = 'appList';
      this.$refs.tableApp.refresh(true);
    },
    handleAppBindListDrawerClose() {
      this.isShowAppBindListDrawer = false;
      this.chooseRowAppId = '';
      this.activeKey = 'appList';
    },
    handleTotalAppChange(value) {
      this.totalApp = value;
    },
  },
};
</script>

<style lang="less" scoped>
.app-page {
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
  height: 100%;

  /deep/.ant-tabs-card {
    .ant-tabs-bar {
      border-color: #fff;

      .ant-tabs-tab {
        border-color: transparent;
        background: rgba(0, 0, 0, 0.02);
      }

      .ant-tabs-tab-active {
        border-color: #fff;
        background: #fff;
      }
    }

    .ant-tabs-content {
      height: 100%;
      padding-top: 40px;

      .app-tab {
        background: #fff;
      }

      .ant-tabs-tabpane {
        display: flex;
        flex-direction: column;

        &.ant-tabs-tabpane-active {
          padding: 0 20px 0 20px;
        }
      }
    }
  }
}

.table-page {
  height: 100%;
  display: flex;
  flex-direction: column;

  &__main {
    flex: 1;
    height: 100%;
  }
}

/deep/.ant-tabs-top-bar {
  z-index: 999;
}
</style>
